import {useEffect, useRef} from 'react'
import {RoomEvent, Track} from 'livekit-client'
import {useTracks} from '@livekit/components-react'
import {STORAGE_KEYS} from '@/shared/config'

/**
 * Requests the focus hint once when there are 2+ unique participants and the user hasn't seen the hint.
 * Must be used inside LiveKitRoom (useTracks requires it).
 */
export function useFocusHintFirstTime(onRequestFocusHint: (() => void) | undefined) {
  const tracks = useTracks(
    [
      {source: Track.Source.Camera, withPlaceholder: true},
      {source: Track.Source.ScreenShare, withPlaceholder: false},
    ],
    {
      updateOnlyOn: [RoomEvent.ActiveSpeakersChanged],
      onlySubscribed: false,
    },
  )
  const hasRequestedRef = useRef(false)

  useEffect(() => {
    if (!onRequestFocusHint || hasRequestedRef.current) return
    if (typeof localStorage === 'undefined') return
    if (localStorage.getItem(STORAGE_KEYS.FOCUS_HINT_SEEN)) return
    const uniqueParticipants = new Set(tracks.map(ref => ref.participant.identity)).size
    if (uniqueParticipants < 2) return
    hasRequestedRef.current = true
    onRequestFocusHint()
  }, [tracks, onRequestFocusHint])
}
